"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CentredSubtle = void 0;
/*
 * © 2017 Renishaw plc. All rights reserved.
 * This source file is the confidential property and copyright of Renishaw plc
 * Reproduction or transmission in whole or in part, in any form or
 * by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 */
const styled_components_1 = require("../styled-components");
const Text_1 = __importDefault(require("./Text"));
const Subtle = (0, styled_components_1.styled)(Text_1.default) `
  opacity: ${({ opacity }) => (opacity ? opacity : 0.6)};
  font-style: italic;
  font-size: 14px;
  color: ${(props) => props.color || props.theme.fg};
`;
exports.CentredSubtle = (0, styled_components_1.styled)(Subtle) `
  align-self: center;
`;
exports.default = Subtle;
//# sourceMappingURL=Subtle.js.map